import { BankTransaction } from "./";
import { Loan } from "./loans";

export interface Bank {
    id: number;
    user_id: number;
    name: string;
    starting_balance: number | null;
    loc: boolean | null;
    loc_interest_rate: number | null;
    loc_balance: number | null;
    loc_interest: number | null;
    loc_total_interest: number | null;
    loans_collection: Loan[];
    bank_transactions_collection: BankTransaction[]
}

export const InitBank: Bank = {
    id: 0,
    user_id: 0,
    name: '',
    starting_balance: null,
    loc: null,
    loc_interest_rate: null,
    loc_balance: null,
    loc_interest: null,
    loc_total_interest: null,
    loans_collection: [],
    bank_transactions_collection: [],
}
